import { OutlinedInput, OutlinedInputProps, useTheme } from "@mui/material";
import { forwardRef, useMemo, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
export type CustomInputProps = { charLength?: number; isNumber?: boolean } & OutlinedInputProps;
export const customInputSxProps = {
  textAlign: "left",
  borderRadius: "0.75rem",

  "&.MuiInputBase-sizeSmall": {
    height: "3rem",
  },
  "&.MuiInputBase-sizeMedium": {
    height: "3.5rem",
  },
  "&.MuiInputBase-adornedStart .MuiOutlinedInput-input": {
    marginLeft: "0.3125rem",
  },
  "& .MuiInputAdornment-root .MuiSvgIcon-root": {
    fontSize: "1.2rem",
  },
  "&.Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
    borderColor: `text.secondary`,
  },
};
export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>((props, ref) => {
  const { sx, charLength: charLength, isNumber: isNumber = false, onChange = () => {}, autoComplete = "off", type, ...others } = props;
  const [showText, setShowText] = useState(type === "password" ? false : true);
  const localType = useMemo(() => {
    if (type === "password") {
      return showText ? "text" : "password";
    }
    return "text";
  }, [showText]);
  const rightAndoment = useMemo(() => {
    if (type === "password") {
      return showText ? <VisibilityOffIcon sx={{ cursor: "pointer" }} onClick={() => setShowText(false)} /> : <VisibilityIcon sx={{ cursor: "pointer" }} onClick={() => setShowText(true)} />;
    }
    return undefined;
  }, [showText]);
  return (
    <OutlinedInput
      inputProps={{
        style: { boxShadow: "none" },
      }}
      sx={[customInputSxProps, ...(Array.isArray(sx) ? sx : [sx])]}
      onChange={(e) => {
        if (charLength && charLength > 0 && e.target.value && e.target.value.length > charLength) {
          return;
        }
        if (type === "number" || isNumber) {
          var value: any = e.target.value;

          if (isNaN(value)) {
            return;
          }
        }
        onChange(e);
      }}
      type={localType}
      ref={ref}
      endAdornment={rightAndoment}
      autoComplete={autoComplete}
      {...others}
    />
  );
});
